import React, { Component } from "react";
import {
    Button,
} from "reactstrap";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import style from "./MediclaimSettings.module.css";
import {
    updateDestinationCodes,
    fetchMedSchemes,
    fetchMedSchemesPlan,
    fetchMedSchemesPlanOptions,
    fetchMedSchemesPlanSubOptions,
    fetchpractitioner
} from "../../../../redux";
import ttmLoader from "../../../../assets/images/ttm-loader.gif";
import { Select, Switch } from "antd";
import Api from "../../../../utils/Api";
import { MedSwitchPackageCodes } from "../../../../utils/BillingConstants";
import swal from "sweetalert";
const { Option } = Select;


export class MediclaimSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            medical_scheme_code: "",
            medical_scheme_plan: "",
            medical_scheme_plan_option: "",
            medical_scheme_plan_suboption: "",
            mediswitch_service_provider: "",
            service_provider_user_id: "",
            package_code: "",
            isDataFetching: false,
            isGlobalFetchLoading: false,
            successMessage: "",
            successMessage2: "",
            errorMessage: "",
            errorMessage2: "",
            successMessage3: "",
            errorMessage3: "",
            mediswitch_test_mode: 1,
            medprax_test_mode: 1,
            isSchemeDatabaseUpdating: false,
        };
    }

    componentDidMount = async () => {
        document.title = 'Claim Settings - TechToMedix';
        await this.props.fetchMedSchemes(this.state.medical_scheme_code);
        this.props.fetchpractitioner("", 1);
        await this.getDefaultScheme()

    }


    // fetching general setting options
    getDefaultScheme = async () => {
        this.setState({
            isDataFetching: true,
        });
        const headers = {
            Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
        try {
            const response = await Api.get("setting/fetch", {
                headers: headers,
            });
           // console.log("Getting response data for general setting - ", response);
            let data = response && response.data && response.data.data &&
                response.data.data.setting
            this.setState(
                {
                    medical_scheme_code: data && data.scheme_code,
                    medical_scheme_plan: data && data.scheme_plan_code,
                    medical_scheme_plan_option: data && data.scheme_plan_option_code,
                    medical_scheme_plan_suboption: data && data.scheme_plan_suboption_code,
                    mediswitch_service_provider: data && data.mediswitch_service_provider,
                    service_provider_user_id: data && data.service_provider_user_id,
                    // package_code: data && data.package_code,
                    // mediswitch_test_mode: data && (data.mediswitch_test_mode === 1) ? 1 : 0,
                    medprax_test_mode: data && (data.medprax_test_mode === 1)? 1 : 0
                },
                () => {
                    this.getAllSchemesData();
                }
            );
        } catch (error) {
            console.log("Error", error);
            this.setState({
                isDataFetching: false,
            });
        }
    };

    getAllSchemesData = () => {
        if (this.state.medical_scheme_code) {
            this.props.fetchMedSchemesPlan(this.state.medical_scheme_code);
        }

        if (this.state.medical_scheme_plan) {
            this.props.fetchMedSchemesPlanOptions(this.state.medical_scheme_plan);
        }

        if (this.state.medical_scheme_plan_option) {
            this.props.fetchMedSchemesPlanSubOptions(this.state.medical_scheme_plan_option);
        }
        this.setState({
            isDataFetching: false,
        });
    }

    updateDestinationCodes = async () => {
        await this.props.updateDestinationCodes();

        if (!this.props.destinationCodesData.loading) {
            if (!this.props.destinationCodesData.destinationCodes.error) {
                this.setState({
                    successMessage2: this.props.destinationCodesData.destinationCodes.message
                })
            } else {
                this.setState({
                    errorMessage2: this.props.destinationCodesData.destinationCodes.message
                })
            }
            setTimeout(() => {
                this.setState({
                    successMessage2: "",
                    errorMessage2: ""
                })
            }, 10000);
        }
    }

    onChangeSchemePlan = (val, name) => {
        // console.log(`selected ${value}`);
        this.setState({
            [name]: val
        });

        if (name === "mediswitch_service_provider") {

            const practitionerObj =
                this.props.practitionerData &&
                this.props.practitionerData.practitioner.find((item, index) => (
                    item.practitioner_id === Number(val)
                ))
            this.setState({
                service_provider_user_id: practitionerObj && practitionerObj.practitioner_user_id ? practitionerObj.practitioner_user_id : ""
            })
        }

        if (name === "medical_scheme_code") {
            console.log("med scheme selected");
            if (this.state.medical_scheme_plan) {
                this.setState({
                    medical_scheme_plan: "",
                });
            }
            if (this.state.medical_scheme_plan_option) {
                this.setState({
                    medical_scheme_plan_option: "",
                });
            }
            if (this.state.medical_scheme_plan_suboption) {
                this.setState({
                    medical_scheme_plan_suboption: "",
                });
            }
            if (val) {
                this.props.fetchMedSchemesPlan(val);
            }
        }

        if (name === "medical_scheme_plan") {
            console.log("med scheme Plan selected");

            if (this.state.medical_scheme_plan_option) {
                this.setState({
                    medical_scheme_plan_option: "",
                });
            }
            if (this.state.medical_scheme_plan_suboption) {
                this.setState({
                    medical_scheme_plan_suboption: "",
                });
            }
            if (val) {
                this.props.fetchMedSchemesPlanOptions(val);
            }
        }

        if (name === "medical_scheme_plan_option") {
            console.log("med scheme Plan option selected");

            if (this.state.medical_scheme_plan_suboption) {
                this.setState({
                    medical_scheme_plan_suboption: "",
                });
            }
            if (val) {
                this.props.fetchMedSchemesPlanSubOptions(val);
            }
        }
    };


    onSubmitDefaultSettings = async (data) => {
        // alert("SUCCESS!! :-)\n\n" + JSON.stringify(fields, null, 4));
        this.setState({
            isDataFetching: true,
            errorMessage: ""
        });

        // Payload to be sent
        const payload = {
            // package_code: this.state.package_code,
            // mediswitch_test_mode: this.state.mediswitch_test_mode,
            medprax_test_mode: this.state.medprax_test_mode,
            mediswitch_service_provider: this.state.mediswitch_service_provider,
            service_provider_user_id: this.state.service_provider_user_id,
            scheme_code: this.state.medical_scheme_code,
            scheme_plan_code: this.state.medical_scheme_plan,
            scheme_plan_option_code: this.state.medical_scheme_plan_option ? this.state.medical_scheme_plan_option : "",
            scheme_plan_suboption_code: this.state.medical_scheme_plan_suboption ? this.state.medical_scheme_plan_suboption : ""
        }
        // Headers
        const headers = {
            Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
        try {
            const response = await Api.post("setting/general/save", payload, {
                headers: headers,
            });
            if (response.status === 200) {
                this.setState({
                    isDataFetching: false,
                    successMessage: "Default settings saved successfully!",
                });
            }
            setTimeout(() => {
                this.setState({
                    successMessage: "",
                });
            }, 2000);
        } catch (error) {
            if (error.response) {
                this.setState({
                    isDataFetching: false,
                    errorMessage: error.response.data &&
                        error.response.data.message ? error.response.data.message : "Internal server error occured",
                });
                // setTimeout(() => {
                //     this.setState({
                //         errorMessage: "",
                //     });
                // }, 10000);
            }
            console.log("Error in save default scheme", error);
        }
    }

    changeGatewayMode = (data) => {
        this.setState({
            mediswitch_test_mode: data === true ? 0 : 1
        }, () => {
            let packageCodeObj = MedSwitchPackageCodes.find((item) =>
                item.test_mode === this.state.mediswitch_test_mode
            );
            this.setState({
                package_code: packageCodeObj && packageCodeObj.package_code ? packageCodeObj.package_code : ""
            })
        })
    }

    changeMedpraxMode = (data) => {
        swal("After save Medprax data environment will get change. Please remember to review settings later.", {
            className: "logout-swal-modal",
            buttons: "ok",
          });
        this.setState({
            medprax_test_mode: data === true ? 0 : 1
        })
    }

    fetchDelayedResponses = async () => {
        this.setState({
            isGlobalFetchLoading: true,
            errorMessage3: ""
        });
        const headers = {
            Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
        try {
            const response = await Api.get("setting/global/fetch", {
                headers: headers,
            });
            console.log("Getting response data for gloabal fetch setting - ", response);
           // let data = response && response.data && response.data.data;
            this.setState({
                successMessage3: "Delayed responses fetched successfully!",
                isGlobalFetchLoading: false
            });
            setTimeout(() => {
                this.setState({
                    successMessage3: ""
                })
            }, 2000);
        } catch (error) {
            console.log("Error", error);
            this.setState({
                errorMessage3: error.response && error.response.data &&
                    error.response.data.message ? error.response.data.message : error.message,
                isGlobalFetchLoading: false
            });
            // setTimeout(() => {
            //     this.setState({
            //         errorMessage3: ""
            //     })
            // }, 10000);
        }
    }


    updateSchemesDatabase = async () => {
        this.setState({
            isSchemeDatabaseUpdating: true,
            errorMessage4: ""
        });
        const headers = {
            Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
        try {
            const response = await Api.get("setting/schemes/update", {
                headers: headers,
            });
            console.log("Getting response data for gloabal fetch setting - ", response);
           // let data = response && response.data && response.data.data;
            this.setState({
                successMessage4: "Delayed responses fetched successfully!",
                isSchemeDatabaseUpdating: false
            });
            setTimeout(() => {
                this.setState({
                    successMessage4: ""
                })
            }, 2000);
        } catch (error) {
            console.log("Error", error);
            this.setState({
                errorMessage4: error.response && error.response.data &&
                    error.response.data.message ? error.response.data.message : error.message,
                isSchemeDatabaseUpdating: false
            });
            // setTimeout(() => {
            //     this.setState({
            //         errorMessage4: ""
            //     })
            // }, 10000);
        }
    }


    render() {

        const schemesDropDownListData = this.props.schemesData.schemes;
        const schemesPlanDropDownListData = this.props.schemesPlanData.schemesPlan;
        const schemesPlanOptionsDropDownListData = this.props.schemesPlanOptionsData.schemesPlanOptions;
        const schemesPlanSubOptionsDropDownListData = this.props.schemesPlanSubOptionsData.schemesPlanSubOptions;
        const practitionerOptions =
            this.props.practitionerData && this.props.practitionerData.practitioner;

        // const mediaclAidSchemeOptions = schemesDropDownListData &&
        //     schemesDropDownListData.map((element, index) => (
        //         <option key={index} value={element.code}>
        //             {element.name} ({element.code})
        //         </option>
        //     ));


        const mediaclAidSchemePlanOptions = schemesPlanDropDownListData &&
            schemesPlanDropDownListData.map((element, index) => (
                <option key={index} value={element.code}>
                    {element.name} ({element.code})
                </option>
            ));


        const mediaclAidSchemePlanOptionsOptions = schemesPlanOptionsDropDownListData &&
            schemesPlanOptionsDropDownListData.map((element, index) => (
                <option key={index} value={element.code}>
                    {element.name} ({element.code})
                </option>
            ));
        const mediaclAidSchemePlanSubOptionsOptions = schemesPlanSubOptionsDropDownListData &&
            schemesPlanSubOptionsDropDownListData.map((element, index) => (
                <option key={index} value={element.code}>
                    {element.name} ({element.code})
                </option>
            ));
        return (
            <div className={`${style.mediclaimSettingsWrapper}`}>
                <div className="row">
                    <div className="col-lg-12">
                        <h3>Claim Settings</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className={style.mediclaimSettingsBoxWrapper}>
                            <div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className={style.mediclaimSettingsMSVWrapper}>
                                            <div className="form-box-shadow mt-4">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <h5>Default Settings</h5>
                                                    </div>
                                                </div>

                                                <Formik
                                                    initialValues={this.state}
                                                    enableReinitialize={true}
                                                    validationSchema={Yup.object().shape({
                                                        mediswitch_service_provider: Yup.string()
                                                            .required("Service Provider is required"),
                                                        // package_code: Yup.string()
                                                        //     .required("Package code is required"),
                                                        medical_scheme_code: Yup.string()
                                                            .required("Scheme Name is required"),
                                                        medical_scheme_plan: Yup.string()
                                                            .required("Scheme Plan is required"),
                                                    })}
                                                    onSubmit={this.onSubmitDefaultSettings}
                                                >
                                                    {({ errors, status, touched }) => (
                                                        <div>
                                                            <Form>

                                                                <div className="row mt-2">
                                                                    {/* <div className="col-md-12 col-lg-12 col-xl-12">
                                                                        <div className="form-group">
                                                                            <label htmlFor="btn">
                                                                                Set gateway mode for mediswitch</label>
                                                                            <div className="row">
                                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                                    <div >
                                                                                        <label className="mr-2" htmlFor="mediswitch_test_mode">Gateway mode
                                                                                        </label>
                                                                                        <Switch
                                                                                            onChange={this.changeGatewayMode}
                                                                                            checkedChildren="Live"
                                                                                            unCheckedChildren="Test"
                                                                                            checked={this.state.mediswitch_test_mode === 0} />

                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div> */}
                                                                    <div className="col-md-12 col-lg-12 col-xl-12">
                                                                        <div className="form-group">
                                                                            <label htmlFor="btn">
                                                                                Set default service provider and package code for claims</label>
                                                                            <div className="row">
                                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                                    <div >
                                                                                        <label htmlFor="mediswitch_service_provider">Service Provider
                                                                                    <span className="mandatory">*</span>
                                                                                        </label>
                                                                                        <Select
                                                                                            showSearch
                                                                                            allowClear={true}
                                                                                            name="mediswitch_service_provider"
                                                                                            placeholder="Search and select practitioner"
                                                                                            optionFilterProp="children"
                                                                                            className={
                                                                                                (errors.mediswitch_service_provider && touched.mediswitch_service_provider
                                                                                                    ? " is-invalid"
                                                                                                    : "")
                                                                                            }
                                                                                            onChange={(value) => this.onChangeSchemePlan(value, "mediswitch_service_provider")}
                                                                                            filterOption={(input, option) =>
                                                                                                option.children.toString()
                                                                                                    .toLowerCase()
                                                                                                    .indexOf(input.toLowerCase()) >= 0
                                                                                            }
                                                                                            value={this.state.mediswitch_service_provider || undefined}
                                                                                        >
                                                                                            {practitionerOptions &&
                                                                                                practitionerOptions.map((element, index) => (
                                                                                                    <Option key={index} title={`${element.practitioner_name}`} value={element.practitioner_id}>
                                                                                                        {element.practitioner_name}
                                                                                                    </Option>
                                                                                                ))}
                                                                                        </Select>
                                                                                        <ErrorMessage
                                                                                            name="mediswitch_service_provider"
                                                                                            component="div"
                                                                                            className="invalid-feedback"
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                {/* <div className="col-md-6 col-lg-4 col-xl-3">
                                                                                    <div >
                                                                                        <label htmlFor="mediswitch_service_provider">Package Code
                                                                                    <span className="mandatory">*</span>
                                                                                        </label>
                                                                                        <Field
                                                                                            name="package_code"
                                                                                            type="text"
                                                                                            placeholder="Package Code"
                                                                                            className={
                                                                                                "form-control" +
                                                                                                (errors.package_code && touched.package_code
                                                                                                    ? " is-invalid"
                                                                                                    : "")
                                                                                            }
                                                                                            onChange={(e) => this.onChangeSchemePlan(e.target.value, e.target.name)}
                                                                                        />
                                                                                        <ErrorMessage
                                                                                            name="package_code"
                                                                                            component="div"
                                                                                            className="invalid-feedback"
                                                                                        />
                                                                                    </div>
                                                                                </div> */}
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12 col-lg-12 col-xl-12">
                                                                        <div className="form-group">
                                                                            <label htmlFor="btn">
                                                                                Set gateway mode for Medprax data</label>
                                                                            <div className="row">
                                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                                    <div >
                                                                                        <label className="mr-2" htmlFor="medprax_test_mode">Gateway mode
                                                                                        </label>
                                                                                        <Switch
                                                                                            onChange={this.changeMedpraxMode}
                                                                                            checkedChildren="Production"
                                                                                            unCheckedChildren="Staging"
                                                                                            checked={this.state.medprax_test_mode === 0} />

                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-12 col-lg-12 col-xl-12">
                                                                        <div className="form-group">
                                                                            <label htmlFor="btn">
                                                                                Set default medical scheme for non-medical aid patients.</label>


                                                                            <div className="row">
                                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                                    <div className="form-group">
                                                                                        <label htmlFor="medical_scheme_code">Medical Scheme Name
                                                                                    <span className="mandatory">*</span>
                                                                                        </label>
                                                                                        <Select
                                                                                            showSearch
                                                                                            allowClear={true}
                                                                                            name="medical_scheme_code"
                                                                                            placeholder="Search and select scheme"
                                                                                            optionFilterProp="children"
                                                                                            className={
                                                                                                (errors.medical_scheme_code && touched.medical_scheme_code
                                                                                                    ? " is-invalid"
                                                                                                    : "")
                                                                                            }
                                                                                            onChange={(value) => this.onChangeSchemePlan(value, "medical_scheme_code")}
                                                                                            filterOption={(input, option) =>
                                                                                                option.children.toString()
                                                                                                    .toLowerCase()
                                                                                                    .indexOf(input.toLowerCase()) >= 0
                                                                                            }
                                                                                            value={this.state.medical_scheme_code || undefined}
                                                                                        >
                                                                                            {schemesDropDownListData &&
                                                                                                schemesDropDownListData.map((element, index) => (
                                                                                                    <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                                                                                                        {element.name} ({element.code})
                                                                                                    </Option>
                                                                                                ))}
                                                                                        </Select>
                                                                                        <ErrorMessage
                                                                                            name="medical_scheme_code"
                                                                                            component="div"
                                                                                            className="invalid-feedback"
                                                                                        />
                                                                                    </div>
                                                                                </div>



                                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                                    <div className="form-group">
                                                                                        <label htmlFor="medical_scheme_plan">Medical Scheme Plan
                                                                                    <span className="mandatory">*</span>
                                                                                        </label>
                                                                                        <Select
                                                                                            showSearch
                                                                                            allowClear={true}
                                                                                            name="medical_scheme_plan"
                                                                                            placeholder="Search and select scheme plan"
                                                                                            disabled={!this.state.medical_scheme_code}
                                                                                            optionFilterProp="children"
                                                                                            className={
                                                                                                (errors.medical_scheme_plan && touched.medical_scheme_plan
                                                                                                    ? "is-invalid"
                                                                                                    : "")
                                                                                            }
                                                                                            onChange={(value) => this.onChangeSchemePlan(value, "medical_scheme_plan")}
                                                                                            filterOption={(input, option) =>
                                                                                                option.children.toString()
                                                                                                    .toLowerCase()
                                                                                                    .indexOf(input.toLowerCase()) >= 0
                                                                                            }
                                                                                            value={this.state.medical_scheme_plan || undefined}
                                                                                        >
                                                                                            {schemesPlanDropDownListData &&
                                                                                                schemesPlanDropDownListData.map((element, index) => (
                                                                                                    <Option key={index} value={element.code}>
                                                                                                        {element.name} ({element.code})
                                                                                                    </Option>
                                                                                                ))}
                                                                                        </Select>
                                                                                        <ErrorMessage
                                                                                            name="medical_scheme_plan"
                                                                                            component="div"
                                                                                            className="invalid-feedback"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                {mediaclAidSchemePlanOptions &&
                                                                                    mediaclAidSchemePlanOptions.length > 0 &&
                                                                                    mediaclAidSchemePlanOptionsOptions &&
                                                                                    mediaclAidSchemePlanOptionsOptions.length > 0 &&
                                                                                    (
                                                                                        <div className="col-md-6 col-lg-4 col-xl-3">
                                                                                            <div className="form-group">
                                                                                                <label htmlFor="medical_scheme_plan_option">Medical Scheme Plan Option
                                                                        {/* <span className="mandatory">*</span> */}
                                                                                                </label>

                                                                                                <Select
                                                                                                    showSearch
                                                                                                    allowClear={true}
                                                                                                    name="medical_scheme_plan_option"
                                                                                                    placeholder="Search and select scheme plan option"
                                                                                                    disabled={!this.state.medical_scheme_plan}
                                                                                                    optionFilterProp="children"
                                                                                                    className={
                                                                                                        (errors.medical_scheme_plan_option && touched.medical_scheme_plan_option
                                                                                                            ? " is-invalid"
                                                                                                            : "")
                                                                                                    }
                                                                                                    onChange={(value) => this.onChangeSchemePlan(value, "medical_scheme_plan_option")}
                                                                                                    filterOption={(input, option) =>
                                                                                                        option.children.toString()
                                                                                                            .toLowerCase()
                                                                                                            .indexOf(input.toLowerCase()) >= 0
                                                                                                    }
                                                                                                    value={this.state.medical_scheme_plan_option || undefined}
                                                                                                >
                                                                                                    {schemesPlanOptionsDropDownListData &&
                                                                                                        schemesPlanOptionsDropDownListData.map((element, index) => (
                                                                                                            <Option key={index} value={element.code}>
                                                                                                                {element.name} ({element.code})
                                                                                                            </Option>
                                                                                                        ))}
                                                                                                </Select>
                                                                                                <ErrorMessage
                                                                                                    name="medical_scheme_plan_option"
                                                                                                    component="div"
                                                                                                    className="invalid-feedback"
                                                                                                />
                                                                                            </div>
                                                                                        </div>)}
                                                                                {mediaclAidSchemePlanOptions &&
                                                                                    mediaclAidSchemePlanOptions.length > 0 &&
                                                                                    mediaclAidSchemePlanOptionsOptions &&
                                                                                    mediaclAidSchemePlanOptionsOptions.length > 0 &&
                                                                                    mediaclAidSchemePlanSubOptionsOptions &&
                                                                                    mediaclAidSchemePlanSubOptionsOptions.length > 0 && (

                                                                                        <div className="col-md-6 col-lg-4 col-xl-3">
                                                                                            <div className="form-group">
                                                                                                <label htmlFor="medical_scheme_plan_suboption">Medical Scheme Plan Suboption
                                                                        {/* <span className="mandatory">*</span> */}
                                                                                                </label>
                                                                                                <Select
                                                                                                    showSearch
                                                                                                    allowClear={true}
                                                                                                    name="medical_scheme_plan_suboption"
                                                                                                    placeholder="Search and select scheme plan suboption"
                                                                                                    disabled={!this.state.medical_scheme_plan_option}
                                                                                                    optionFilterProp="children"
                                                                                                    className={
                                                                                                        (errors.medical_scheme_plan_suboption && touched.medical_scheme_plan_suboption
                                                                                                            ? " is-invalid"
                                                                                                            : "")
                                                                                                    }
                                                                                                    onChange={(value) => this.onChangeSchemePlan(value, "medical_scheme_plan_suboption")}
                                                                                                    filterOption={(input, option) =>
                                                                                                        option.children.toString()
                                                                                                            .toLowerCase()
                                                                                                            .indexOf(input.toLowerCase()) >= 0
                                                                                                    }
                                                                                                    value={this.state.medical_scheme_plan_suboption || undefined}
                                                                                                >
                                                                                                    {schemesPlanSubOptionsDropDownListData &&
                                                                                                        schemesPlanSubOptionsDropDownListData.map((element, index) => (
                                                                                                            <Option key={index} value={element.code}>
                                                                                                                {element.name} ({element.code})
                                                                                                            </Option>
                                                                                                        ))}
                                                                                                </Select>
                                                                                                <ErrorMessage
                                                                                                    name="medical_scheme_plan_suboption"
                                                                                                    component="div"
                                                                                                    className="invalid-feedback"
                                                                                                />
                                                                                            </div>
                                                                                        </div>)}
                                                                            </div>

                                                                            <div class="row" >
                                                                                <div className="col-md-12">
                                                                                    <Button
                                                                                        className="ttm-primary-btn mt-1"
                                                                                        type="submit"
                                                                                    >
                                                                                        Save
                                                                    </Button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12 col-lg-12 col-xl-12">
                                                                        {this.state.isDataFetching && (
                                                                            <div className={`error ${style.loadingWrapper}`}>
                                                                                <img src={ttmLoader} alt="loader" className={style.loading} />
                                                                            </div>
                                                                        )}
                                                                        {!this.state.isDataFetching && this.state.successMessage &&
                                                                            (
                                                                                <div>
                                                                                    <p className={style.successMessage}>{this.state.successMessage}</p>
                                                                                </div>
                                                                            )}
                                                                        {!this.state.isDataFetching && this.state.errorMessage && (
                                                                            <div>

                                                                                <p className={style.errorMessage}>{this.state.errorMessage}</p>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </Form>
                                                        </div>)}
                                                </Formik>





                                            </div>

                                        </div>


                                        <div className={style.mediclaimSettingsMSVWrapper}>
                                            <div className="form-box-shadow mt-4">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <h5>Destination Code Fetch</h5>
                                                    </div>
                                                </div>

                                                <div className="row mt-2">
                                                    <div className="col-md-12 col-lg-12 col-xl-12">
                                                        <div className="form-group">
                                                            <label htmlFor="btn">
                                                                This will update latest Destination Codes in Database from the mediswitch APIs. (This may take few minutes to complete. Thanks for your patience.)</label>
                                                            <div>
                                                                <Button
                                                                    className="ttm-primary-btn mt-1"
                                                                    type="button"
                                                                    onClick={this.updateDestinationCodes}
                                                                >
                                                                    Update Destination Codes
                                                                    </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 col-lg-12 col-xl-12">
                                                        {this.props.destinationCodesData.loading && (
                                                            <div className={`error ${style.loadingWrapper}`}>
                                                                <img src={ttmLoader} alt="loader" className={style.loading} />
                                                            </div>
                                                        )}
                                                        {!this.props.destinationCodesData.loading && this.state.successMessage2 &&
                                                            (
                                                                <div>
                                                                    <p className={style.successMessage}>{this.state.successMessage2}</p>
                                                                </div>
                                                            )}
                                                        {!this.props.destinationCodesData.loading && this.state.errorMessage2 && (
                                                            <div>

                                                                <p className={style.errorMessage}>{this.state.errorMessage2}</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>


                                        <div className={style.mediclaimSettingsMSVWrapper}>
                                            <div className="form-box-shadow mt-4">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <h5>Global Fetch (Delayed Responses)</h5>
                                                    </div>
                                                </div>

                                                <div className="row mt-2">
                                                    <div className="col-md-12 col-lg-12 col-xl-12">
                                                        <div className="form-group">
                                                            <label htmlFor="btn">
                                                                This will fetch all the delayed responses of claims.</label>
                                                            <div>
                                                                <Button
                                                                    className="ttm-primary-btn mt-1"
                                                                    type="button"
                                                                    onClick={this.fetchDelayedResponses}
                                                                >
                                                                    Fetch
                                                                    </Button>
                                                            </div>
                                                        </div>
                                                        {this.state.isGlobalFetchLoading && (
                                                            <div className={`error ${style.loadingWrapper}`}>
                                                                <img src={ttmLoader} alt="loader" className={style.loading} />
                                                            </div>
                                                        )}
                                                        {!this.state.isGlobalFetchLoading && this.state.successMessage3 &&
                                                            (
                                                                <div>
                                                                    <p className={style.successMessage}>{this.state.successMessage3}</p>
                                                                </div>
                                                            )}
                                                        {!this.state.isGlobalFetchLoading && this.state.errorMessage3 && (
                                                            <div>

                                                                <p className={style.errorMessage}>{this.state.errorMessage3}</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                        {/* <div className={style.mediclaimSettingsMSVWrapper}>
                                            <div className="form-box-shadow mt-4">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <h5>Update Schemes Database</h5>
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-md-12 col-lg-12 col-xl-12">
                                                        <div className="form-group">
                                                            <label htmlFor="btn">
                                                                This will update schemes database on system.</label>
                                                            <div>
                                                                <Button
                                                                    className="ttm-primary-btn mt-1"
                                                                    type="button"
                                                                    onClick={this.updateSchemesDatabase}
                                                                >
                                                                    Update Schemes
                                                                    </Button>
                                                            </div>
                                                        </div>
                                                        {this.state.isSchemeDatabaseUpdating && (
                                                            <div className={`error ${style.loadingWrapper}`}>
                                                                <img src={ttmLoader} alt="loader" className={style.loading} />
                                                            </div>
                                                        )}
                                                        {!this.state.isSchemeDatabaseUpdating && this.state.successMessage4 &&
                                                            (
                                                                <div>
                                                                    <p className={style.successMessage}>{this.state.successMessage4}</p>
                                                                </div>
                                                            )}
                                                        {!this.state.isSchemeDatabaseUpdating && this.state.errorMessage4 && (
                                                            <div>

                                                                <p className={style.errorMessage}>{this.state.errorMessage4}</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}


                                    </div>
                                </div>
                            </div>
                        </div>




                    </div>
                </div>
            </div>


        );
    }
}

const mapStateToProps = (state) => {
    return {
        destinationCodesData: state.destinationCodes,
        schemesData: state.schemes,
        schemesPlanData: state.schemesPlan,
        schemesPlanOptionsData: state.schemesPlanOptions,
        schemesPlanSubOptionsData: state.schemesPlanSubOptions,
        practitionerData: state.practitioner,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchpractitioner: (practitionerName, isBillingPractitioner) => dispatch(fetchpractitioner(practitionerName, isBillingPractitioner)),
        updateDestinationCodes: () => dispatch(updateDestinationCodes()),
        fetchMedSchemes: (scheme) => dispatch(fetchMedSchemes(scheme)),
        fetchMedSchemesPlan: (scheme_code) => dispatch(fetchMedSchemesPlan(scheme_code)),
        fetchMedSchemesPlanOptions: (plan_code) => dispatch(fetchMedSchemesPlanOptions(plan_code)),
        fetchMedSchemesPlanSubOptions: (plan_option_code) => dispatch(fetchMedSchemesPlanSubOptions(plan_option_code)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MediclaimSettings);
